export const paises = {
  1: {
    nome: "Afeganistão",
    sigla2: "AF",
    sigla3: "AFG",
  },
  2: {
    nome: "África do Sul",
    sigla2: "ZA",
    sigla3: "ZAF",
  },
  3: {
    nome: "Albânia",
    sigla2: "AL",
    sigla3: "ALB",
  },
  4: {
    nome: "Alemanha",
    sigla2: "DE",
    sigla3: "DEU",
  },
  5: {
    nome: "Andorra",
    sigla2: "AD",
    sigla3: "AND",
  },
  6: {
    nome: "Angola",
    sigla2: "AO",
    sigla3: "AGO",
  },
  7: {
    nome: "Anguilla",
    sigla2: "AI",
    sigla3: "AIA",
  },
  8: {
    nome: "Antártida",
    sigla2: "AQ",
    sigla3: "ATA",
  },
  9: {
    nome: "Antígua e Barbuda",
    sigla2: "AG",
    sigla3: "ATG",
  },
  10: {
    nome: "Antilhas Holandesas",
    sigla2: "AN",
    sigla3: "ANT",
  },
  11: {
    nome: "Arábia Saudita",
    sigla2: "SA",
    sigla3: "SAU",
  },
  12: {
    nome: "Argélia",
    sigla2: "DZ",
    sigla3: "DZA",
  },
  13: {
    nome: "Argentina",
    sigla2: "AR",
    sigla3: "ARG",
  },
  14: {
    nome: "Armênia",
    sigla2: "AM",
    sigla3: "ARM",
  },
  15: {
    nome: "Aruba",
    sigla2: "AW",
    sigla3: "ABW",
  },
  16: {
    nome: "Austrália",
    sigla2: "AU",
    sigla3: "AUS",
  },
  17: {
    nome: "Áustria",
    sigla2: "AT",
    sigla3: "AUT",
  },
  18: {
    nome: "Azerbaijão",
    sigla2: "AZ  ",
    sigla3: "AZE",
  },
  19: {
    nome: "Bahamas",
    sigla2: "BS",
    sigla3: "BHS",
  },
  20: {
    nome: "Bahrein",
    sigla2: "BH",
    sigla3: "BHR",
  },
  21: {
    nome: "Bangladesh",
    sigla2: "BD",
    sigla3: "BGD",
  },
  22: {
    nome: "Barbados",
    sigla2: "BB",
    sigla3: "BRB",
  },
  23: {
    nome: "Belarus",
    sigla2: "BY",
    sigla3: "BLR",
  },
  24: {
    nome: "Bélgica",
    sigla2: "BE",
    sigla3: "BEL",
  },
  25: {
    nome: "Belize",
    sigla2: "BZ",
    sigla3: "BLZ",
  },
  26: {
    nome: "Benin",
    sigla2: "BJ",
    sigla3: "BEN",
  },
  27: {
    nome: "Bermudas",
    sigla2: "BM",
    sigla3: "BMU",
  },
  28: {
    nome: "Bolívia",
    sigla2: "BO",
    sigla3: "BOL",
  },
  29: {
    nome: "Bósnia-Herzegóvina",
    sigla2: "BA",
    sigla3: "BIH",
  },
  30: {
    nome: "Botsuana",
    sigla2: "BW",
    sigla3: "BWA",
  },
  31: {
    nome: "Brunei",
    sigla2: "BN",
    sigla3: "BRN",
  },
  32: {
    nome: "Bulgária",
    sigla2: "BG",
    sigla3: "BGR",
  },
  33: {
    nome: "Burkina Fasso",
    sigla2: "BF",
    sigla3: "BFA",
  },
  34: {
    nome: "Burundi",
    sigla2: "BI",
    sigla3: "BDI",
  },
  35: {
    nome: "Butão",
    sigla2: "BT",
    sigla3: "BTN",
  },
  36: {
    nome: "Cabo Verde",
    sigla2: "CV",
    sigla3: "CPV",
  },
  37: {
    nome: "Camarões",
    sigla2: "CM",
    sigla3: "CMR",
  },
  38: {
    nome: "Camboja",
    sigla2: "KH",
    sigla3: "KHM",
  },
  39: {
    nome: "Canadá",
    sigla2: "CA",
    sigla3: "CAN",
  },
  40: {
    nome: "Cazaquistão",
    sigla2: "KZ",
    sigla3: "KAZ",
  },
  41: {
    nome: "Chade",
    sigla2: "TD",
    sigla3: "TCD",
  },
  42: {
    nome: "Chile",
    sigla2: "CL",
    sigla3: "CHL",
  },
  43: {
    nome: "China",
    sigla2: "CN",
    sigla3: "CHN",
  },
  44: {
    nome: "Chipre",
    sigla2: "CY",
    sigla3: "CYP",
  },
  45: {
    nome: "Cingapura",
    sigla2: "SG",
    sigla3: "SGP",
  },
  46: {
    nome: "Colômbia",
    sigla2: "CO",
    sigla3: "COL",
  },
  47: {
    nome: "Congo",
    sigla2: "CG",
    sigla3: "COG",
  },
  48: {
    nome: "Coréia do Norte",
    sigla2: "KP",
    sigla3: "PRK",
  },
  49: {
    nome: "Coréia do Sul",
    sigla2: "KR",
    sigla3: "KOR",
  },
  50: {
    nome: "Costa do Marfim",
    sigla2: "CI",
    sigla3: "CIV",
  },
  51: {
    nome: "Costa Rica",
    sigla2: "CR",
    sigla3: "CRI",
  },
  52: {
    nome: "Croácia (Hrvatska)",
    sigla2: "HR",
    sigla3: "HRV",
  },
  53: {
    nome: "Cuba",
    sigla2: "CU",
    sigla3: "CUB",
  },
  54: {
    nome: "Dinamarca",
    sigla2: "DK",
    sigla3: "DNK",
  },
  55: {
    nome: "Djibuti",
    sigla2: "DJ",
    sigla3: "DJI",
  },
  56: {
    nome: "Dominica",
    sigla2: "DM",
    sigla3: "DMA",
  },
  57: {
    nome: "Egito",
    sigla2: "EG",
    sigla3: "EGY",
  },
  58: {
    nome: "El Salvador",
    sigla2: "SV",
    sigla3: "SLV",
  },
  59: {
    nome: "Emirados Árabes Unidos",
    sigla2: "AE",
    sigla3: "ARE",
  },
  60: {
    nome: "Equador",
    sigla2: "EC",
    sigla3: "ECU",
  },
  61: {
    nome: "Eritréia",
    sigla2: "ER",
    sigla3: "ERI",
  },
  62: {
    nome: "Eslováquia",
    sigla2: "SK",
    sigla3: "SVK",
  },
  63: {
    nome: "Eslovênia",
    sigla2: "SI",
    sigla3: "SVN",
  },
  64: {
    nome: "Espanha",
    sigla2: "ES",
    sigla3: "ESP",
  },
  65: {
    nome: "Estados Unidos",
    sigla2: "US",
    sigla3: "USA",
  },
  66: {
    nome: "Estônia",
    sigla2: "EE",
    sigla3: "EST",
  },
  67: {
    nome: "Etiópia",
    sigla2: "ET",
    sigla3: "ETH",
  },
  68: {
    nome: "Fiji",
    sigla2: "FJ",
    sigla3: "FJI",
  },
  69: {
    nome: "Filipinas",
    sigla2: "PH",
    sigla3: "PHL",
  },
  70: {
    nome: "Finlândia",
    sigla2: "FI",
    sigla3: "FIN",
  },
  71: {
    nome: "França",
    sigla2: "FR",
    sigla3: "FRA",
  },
  72: {
    nome: "Gabão",
    sigla2: "GA",
    sigla3: "GAB",
  },
  73: {
    nome: "Gâmbia",
    sigla2: "GM",
    sigla3: "GMB",
  },
  74: {
    nome: "Gana",
    sigla2: "GH",
    sigla3: "GHA",
  },
  75: {
    nome: "Geórgia",
    sigla2: "GE",
    sigla3: "GEO",
  },
  76: {
    nome: "Gibraltar",
    sigla2: "GI",
    sigla3: "GIB",
  },
  77: {
    nome: "Grã-Bretanha (Reino Unido, UK)",
    sigla2: "GB",
    sigla3: "GBR",
  },
  78: {
    nome: "Granada",
    sigla2: "GD",
    sigla3: "GRD",
  },
  79: {
    nome: "Grécia",
    sigla2: "GR",
    sigla3: "GRC",
  },
  80: {
    nome: "Groelândia",
    sigla2: "GL",
    sigla3: "GRL",
  },
  81: {
    nome: "Guadalupe",
    sigla2: "GP",
    sigla3: "GLP",
  },
  82: {
    nome: "Guam (Território dos Estados Unidos)",
    sigla2: "GU",
    sigla3: "GUM",
  },
  83: {
    nome: "Guatemala",
    sigla2: "GT",
    sigla3: "GTM",
  },
  84: {
    nome: "Guernsey",
    sigla2: "G",
    sigla3: "GGY",
  },
  85: {
    nome: "Guiana",
    sigla2: "GY",
    sigla3: "GUY",
  },
  86: {
    nome: "Guiana Francesa",
    sigla2: "GF",
    sigla3: "GUF",
  },
  87: {
    nome: "Guiné",
    sigla2: "GN",
    sigla3: "GIN",
  },
  88: {
    nome: "Guiné Equatorial",
    sigla2: "GQ",
    sigla3: "GNQ",
  },
  89: {
    nome: "Guiné-Bissau",
    sigla2: "GW",
    sigla3: "GNB",
  },
  90: {
    nome: "Haiti",
    sigla2: "HT",
    sigla3: "HTI",
  },
  91: {
    nome: "Holanda",
    sigla2: "NL",
    sigla3: "NLD",
  },
  92: {
    nome: "Honduras",
    sigla2: "HN",
    sigla3: "HND",
  },
  93: {
    nome: "Hong Kong",
    sigla2: "HK",
    sigla3: "HKG",
  },
  94: {
    nome: "Hungria",
    sigla2: "HU",
    sigla3: "HUN",
  },
  95: {
    nome: "Iêmen",
    sigla2: "YE",
    sigla3: "YEM",
  },
  96: {
    nome: "Ilha Bouvet (Território da Noruega)",
    sigla2: "BV",
    sigla3: "BVT",
  },
  97: {
    nome: "Ilha do Homem",
    sigla2: "IM",
    sigla3: "IMN",
  },
  98: {
    nome: "Ilha Natal",
    sigla2: "CX",
    sigla3: "CXR",
  },
  99: {
    nome: "Ilha Pitcairn",
    sigla2: "PN",
    sigla3: "PCN",
  },
  100: {
    nome: "Ilha Reunião",
    sigla2: "RE",
    sigla3: "REU",
  },
  101: {
    nome: "Ilhas Aland",
    sigla2: "AX",
    sigla3: "ALA",
  },
  102: {
    nome: "Ilhas Cayman",
    sigla2: "KY",
    sigla3: "CYM",
  },
  103: {
    nome: "Ilhas Cocos",
    sigla2: "CC",
    sigla3: "CCK",
  },
  104: {
    nome: "Ilhas Comores",
    sigla2: "KM",
    sigla3: "COM",
  },
  105: {
    nome: "Ilhas Cook",
    sigla2: "CK",
    sigla3: "COK",
  },
  106: {
    nome: "Ilhas Faroes",
    sigla2: "FO",
    sigla3: "FRO",
  },
  107: {
    nome: "Ilhas Falkland (Malvinas)",
    sigla2: "FK",
    sigla3: "FLK",
  },
  108: {
    nome: "Ilhas Geórgia do Sul e Sandwich do Sul",
    sigla2: "GS",
    sigla3: "SGS",
  },
  109: {
    nome: "Ilhas Heard e McDonald (Território da Austrália)",
    sigla2: "HM",
    sigla3: "HMD",
  },
  110: {
    nome: "Ilhas Marianas do Norte",
    sigla2: "MP",
    sigla3: "MNP",
  },
  111: {
    nome: "Ilhas Marshall",
    sigla2: "MH",
    sigla3: "MHL",
  },
  112: {
    nome: "Ilhas Menores dos Estados Unidos",
    sigla2: "UM",
    sigla3: "UMI",
  },
  113: {
    nome: "Ilhas Norfolk",
    sigla2: "NF",
    sigla3: "NFK",
  },
  114: {
    nome: "Ilhas Seychelles",
    sigla2: "SC",
    sigla3: "SYC",
  },
  115: {
    nome: "Ilhas Solomão",
    sigla2: "SB",
    sigla3: "SLB",
  },
  116: {
    nome: "Ilhas Svalbard e Jan Mayen",
    sigla2: "SJ",
    sigla3: "SJM",
  },
  117: {
    nome: "Ilhas Tokelau",
    sigla2: "TK",
    sigla3: "TKL",
  },
  118: {
    nome: "Ilhas Turks e Caicos",
    sigla2: "TC",
    sigla3: "TCA",
  },
  119: {
    nome: "Ilhas Virgens (Estados Unidos)",
    sigla2: "VI",
    sigla3: "VIR",
  },
  120: {
    nome: "Ilhas Virgens (Inglaterra)",
    sigla2: "VG",
    sigla3: "VGB",
  },
  121: {
    nome: "Ilhas Wallis e Futuna",
    sigla2: "WF",
    sigla3: "WLF",
  },
  122: {
    nome: "índia",
    sigla2: "IN",
    sigla3: "IND",
  },
  123: {
    nome: "Indonésia",
    sigla2: "ID",
    sigla3: "IDN",
  },
  124: {
    nome: "Irã",
    sigla2: "IR",
    sigla3: "IRN",
  },
  125: {
    nome: "Iraque",
    sigla2: "IQ",
    sigla3: "IRQ",
  },
  126: {
    nome: "Irlanda",
    sigla2: "IE",
    sigla3: "IRL",
  },
  127: {
    nome: "Islândia",
    sigla2: "IS",
    sigla3: "ISL",
  },
  128: {
    nome: "Israel",
    sigla2: "IL",
    sigla3: "ISR",
  },
  129: {
    nome: "Itália",
    sigla2: "IT",
    sigla3: "ITA",
  },
  130: {
    nome: "Jamaica",
    sigla2: "JM",
    sigla3: "JAM",
  },
  131: {
    nome: "Japão",
    sigla2: "JP",
    sigla3: "JPN",
  },
  132: {
    nome: "Jersey",
    sigla2: "JE",
    sigla3: "JEY",
  },
  133: {
    nome: "Jordânia",
    sigla2: "JO",
    sigla3: "JOR",
  },
  134: {
    nome: "Kênia",
    sigla2: "KE",
    sigla3: "KEN",
  },
  135: {
    nome: "Kiribati",
    sigla2: "KI",
    sigla3: "KIR",
  },
  136: {
    nome: "Kuait",
    sigla2: "KW",
    sigla3: "KWT",
  },
  137: {
    nome: "Laos",
    sigla2: "LA",
    sigla3: "LAO",
  },
  138: {
    nome: "Látvia",
    sigla2: "LV",
    sigla3: "LVA",
  },
  139: {
    nome: "Lesoto",
    sigla2: "LS",
    sigla3: "LSO",
  },
  140: {
    nome: "Líbano",
    sigla2: "LB",
    sigla3: "LBN",
  },
  141: {
    nome: "Libéria",
    sigla2: "LR",
    sigla3: "LBR",
  },
  142: {
    nome: "Líbia",
    sigla2: "LY",
    sigla3: "LBY",
  },
  143: {
    nome: "Liechtenstein",
    sigla2: "LI",
    sigla3: "LIE",
  },
  144: {
    nome: "Lituânia",
    sigla2: "LT",
    sigla3: "LTU",
  },
  145: {
    nome: "Luxemburgo",
    sigla2: "LU",
    sigla3: "LUX",
  },
  146: {
    nome: "Macau",
    sigla2: "MO",
    sigla3: "MAC",
  },
  147: {
    nome: "Macedônia (República Yugoslava)",
    sigla2: "MK",
    sigla3: "MKD",
  },
  148: {
    nome: "Madagascar",
    sigla2: "MG",
    sigla3: "MDG",
  },
  149: {
    nome: "Malásia",
    sigla2: "MY",
    sigla3: "MYS",
  },
  150: {
    nome: "Malaui",
    sigla2: "MW",
    sigla3: "MWI",
  },
  151: {
    nome: "Maldivas",
    sigla2: "MV",
    sigla3: "MDV",
  },
  152: {
    nome: "Mali",
    sigla2: "ML",
    sigla3: "MLI",
  },
  153: {
    nome: "Malta",
    sigla2: "MT",
    sigla3: "MLT",
  },
  154: {
    nome: "Marrocos",
    sigla2: "MA",
    sigla3: "MAR",
  },
  155: {
    nome: "Martinica",
    sigla2: "MQ",
    sigla3: "MTQ",
  },
  156: {
    nome: "Maurício",
    sigla2: "MU",
    sigla3: "MUS",
  },
  157: {
    nome: "Mauritânia",
    sigla2: "MR",
    sigla3: "MRT",
  },
  158: {
    nome: "Mayotte",
    sigla2: "YT",
    sigla3: "MYT",
  },
  159: {
    nome: "México",
    sigla2: "MX",
    sigla3: "MEX",
  },
  160: {
    nome: "Micronésia",
    sigla2: "FM",
    sigla3: "FSM",
  },
  161: {
    nome: "Moçambique",
    sigla2: "MZ",
    sigla3: "MOZ",
  },
  162: {
    nome: "Moldova",
    sigla2: "MD",
    sigla3: "MDA",
  },
  163: {
    nome: "Mônaco",
    sigla2: "MC",
    sigla3: "MCO",
  },
  164: {
    nome: "Mongólia",
    sigla2: "MN",
    sigla3: "MNG",
  },
  165: {
    nome: "Montenegro",
    sigla2: "ME",
    sigla3: "MNE",
  },
  166: {
    nome: "Montserrat",
    sigla2: "MS",
    sigla3: "MSR",
  },
  167: {
    nome: "Myanma",
    sigla2: "MM",
    sigla3: "MMR",
  },
  168: {
    nome: "Namíbia",
    sigla2: "NA",
    sigla3: "NAM",
  },
  169: {
    nome: "Nauru",
    sigla2: "NR",
    sigla3: "NRU",
  },
  170: {
    nome: "Nepal",
    sigla2: "NP",
    sigla3: "NPL",
  },
  171: {
    nome: "Nicarágua",
    sigla2: "NI",
    sigla3: "NIC",
  },
  172: {
    nome: "Níger",
    sigla2: "NE",
    sigla3: "NER",
  },
  173: {
    nome: "Nigéria",
    sigla2: "NG",
    sigla3: "NGA",
  },
  174: {
    nome: "Niue",
    sigla2: "NU",
    sigla3: "NIU",
  },
  175: {
    nome: "Noruega",
    sigla2: "NO",
    sigla3: "NOR",
  },
  176: {
    nome: "Nova Caledônia",
    sigla2: "NC",
    sigla3: "NCL",
  },
  177: {
    nome: "Nova Zelândia",
    sigla2: "NZ",
    sigla3: "NZL",
  },
  178: {
    nome: "Omã",
    sigla2: "OM",
    sigla3: "OMN",
  },
  179: {
    nome: "Palau",
    sigla2: "PW",
    sigla3: "PLW",
  },
  180: {
    nome: "Panamá",
    sigla2: "PA",
    sigla3: "PAN",
  },
  181: {
    nome: "Papua-Nova Guiné",
    sigla2: "PG",
    sigla3: "PNG",
  },
  182: {
    nome: "Paquistão",
    sigla2: "PK",
    sigla3: "PAK",
  },
  183: {
    nome: "Paraguai",
    sigla2: "PY",
    sigla3: "PRY",
  },
  184: {
    nome: "Peru",
    sigla2: "PE",
    sigla3: "PER",
  },
  185: {
    nome: "Polinésia Francesa",
    sigla2: "PF",
    sigla3: "PYF",
  },
  186: {
    nome: "Polônia",
    sigla2: "PL",
    sigla3: "POL",
  },
  187: {
    nome: "Porto Rico",
    sigla2: "PR",
    sigla3: "PRI",
  },
  188: {
    nome: "Portugal",
    sigla2: "PT",
    sigla3: "PRT",
  },
  189: {
    nome: "Qatar",
    sigla2: "QA",
    sigla3: "QAT",
  },
  190: {
    nome: "Quirguistão",
    sigla2: "KG",
    sigla3: "KGZ",
  },
  191: {
    nome: "República Centro-Africana",
    sigla2: "CF",
    sigla3: "CAF",
  },
  192: {
    nome: "República Democrática do Congo",
    sigla2: "CD",
    sigla3: "COD",
  },
  193: {
    nome: "República Dominicana",
    sigla2: "DO",
    sigla3: "DOM",
  },
  194: {
    nome: "República Tcheca",
    sigla2: "CZ",
    sigla3: "CZE",
  },
  195: {
    nome: "Romênia",
    sigla2: "RO",
    sigla3: "ROM",
  },
  196: {
    nome: "Ruanda",
    sigla2: "RW",
    sigla3: "RWA",
  },
  197: {
    nome: "Rússia (antiga URSS) - Federação Russa",
    sigla2: "RU",
    sigla3: "RUS",
  },
  198: {
    nome: "Saara Ocidental",
    sigla2: "EH",
    sigla3: "ESH",
  },
  199: {
    nome: "Saint Vincente e Granadinas",
    sigla2: "VC",
    sigla3: "VCT",
  },
  200: {
    nome: "Samoa Americana",
    sigla2: "AS",
    sigla3: "ASM",
  },
  201: {
    nome: "Samoa Ocidental",
    sigla2: "WS",
    sigla3: "WSM",
  },
  202: {
    nome: "San Marino",
    sigla2: "SM",
    sigla3: "SMR",
  },
  203: {
    nome: "Santa Helena",
    sigla2: "SH",
    sigla3: "SHN",
  },
  204: {
    nome: "Santa Lúcia",
    sigla2: "LC",
    sigla3: "LCA",
  },
  205: {
    nome: "São Bartolomeu",
    sigla2: "BL",
    sigla3: "BLM",
  },
  206: {
    nome: "São Cristóvão e Névis",
    sigla2: "KN",
    sigla3: "KNA",
  },
  207: {
    nome: "São Martim",
    sigla2: "MF",
    sigla3: "MAF",
  },
  208: {
    nome: "São Tomé e Príncipe",
    sigla2: "ST",
    sigla3: "STP",
  },
  209: {
    nome: "Senegal",
    sigla2: "SN",
    sigla3: "SEN",
  },
  210: {
    nome: "Serra Leoa",
    sigla2: "SL",
    sigla3: "SLE",
  },
  211: {
    nome: "Sérvia",
    sigla2: "RS",
    sigla3: "SRB",
  },
  212: {
    nome: "Síria",
    sigla2: "SY",
    sigla3: "SYR",
  },
  213: {
    nome: "Somália",
    sigla2: "SO",
    sigla3: "SOM",
  },
  214: {
    nome: "Sri Lanka",
    sigla2: "LK",
    sigla3: "LKA",
  },
  215: {
    nome: "St. Pierre and Miquelon",
    sigla2: "PM",
    sigla3: "SPM",
  },
  216: {
    nome: "Suazilândia",
    sigla2: "SZ",
    sigla3: "SWZ",
  },
  217: {
    nome: "Sudão",
    sigla2: "SD",
    sigla3: "SDN",
  },
  218: {
    nome: "Suécia",
    sigla2: "SE",
    sigla3: "SWE",
  },
  219: {
    nome: "Suíça",
    sigla2: "CH",
    sigla3: "CHE",
  },
  220: {
    nome: "Suriname",
    sigla2: "SR",
    sigla3: "SUR",
  },
  221: {
    nome: "Tadjiquistão",
    sigla2: "TJ",
    sigla3: "TJK",
  },
  222: {
    nome: "Tailândia",
    sigla2: "TH",
    sigla3: "THA",
  },
  223: {
    nome: "Taiwan",
    sigla2: "TW",
    sigla3: "TWN",
  },
  224: {
    nome: "Tanzânia",
    sigla2: "TZ",
    sigla3: "TZA",
  },
  225: {
    nome: "Território Britânico do Oceano índico",
    sigla2: "IO",
    sigla3: "IOT",
  },
  226: {
    nome: "Territórios do Sul da França",
    sigla2: "TF",
    sigla3: "ATF",
  },
  227: {
    nome: "Territórios Palestinos Ocupados",
    sigla2: "PS",
    sigla3: "PSE",
  },
  228: {
    nome: "Timor Leste",
    sigla2: "TP",
    sigla3: "TMP",
  },
  229: {
    nome: "Togo",
    sigla2: "TG",
    sigla3: "TGO",
  },
  230: {
    nome: "Tonga",
    sigla2: "TO",
    sigla3: "TON",
  },
  231: {
    nome: "Trinidad and Tobago",
    sigla2: "TT",
    sigla3: "TTO",
  },
  232: {
    nome: "Tunísia",
    sigla2: "TN",
    sigla3: "TUN",
  },
  233: {
    nome: "Turcomenistão",
    sigla2: "TM",
    sigla3: "TKM",
  },
  234: {
    nome: "Turquia",
    sigla2: "TR",
    sigla3: "TUR",
  },
  235: {
    nome: "Tuvalu",
    sigla2: "TV",
    sigla3: "TUV",
  },
  236: {
    nome: "Ucrânia",
    sigla2: "UA",
    sigla3: "UKR",
  },
  237: {
    nome: "Uganda",
    sigla2: "UG",
    sigla3: "UGA",
  },
  238: {
    nome: "Uruguai",
    sigla2: "UY",
    sigla3: "URY",
  },
  239: {
    nome: "Uzbequistão",
    sigla2: "UZ",
    sigla3: "UZB",
  },
  240: {
    nome: "Vanuatu",
    sigla2: "VU",
    sigla3: "VUT",
  },
  241: {
    nome: "Vaticano",
    sigla2: "VA",
    sigla3: "VAT",
  },
  242: {
    nome: "Venezuela",
    sigla2: "VE",
    sigla3: "VEN",
  },
  243: {
    nome: "Vietnã",
    sigla2: "VN",
    sigla3: "VNM",
  },
  244: {
    nome: "Zâmbia",
    sigla2: "ZM",
    sigla3: "ZMB",
  },
  245: {
    nome: "Zimbábue",
    sigla2: "ZW",
    sigla3: "ZWE",
  },
  246: {
    nome: "Curaçao",
    sigla2: "CW",
    sigla3: "CUW",
  },
};
